module.exports = __webpack_public_path__ + "888c9c0b1bd73774324f5c617171e780.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/feet.png
// module id = 1759
// module chunks = 0